<strong [hidden]="!showPrimaryLabel || (address.PRI_ADDR_FLG && address.PRI_ADDR_FLG.to_display && address.PRI_ADDR_FLG.to_display == 'N')">
    {{primaryLabel}}: {{address.PRI_ADDR_FLG.value}}
</strong>
<div>
    <span *ngIf="addressToDisplay.length > 0">{{ addressToDisplay.join(', ') }}</span>
</div>